import NRDataActions from "@redux/feature/NRDashboard/action/NRDataActions";
import ProductDataActions from "@redux/feature/NRDashboard/action/ProductDataActions";
import NRHeaderDataActions from "@redux/feature/NRDashboard/action/NRHeaderDataActions";
import EmployeeActions from "@redux/feature/NRDashboard/action/EmployeeActions";
import PartnerNRSummaryDataActions from "@redux/feature/PartnerNRDashboard/action/ProductDataActions";
export default (function () {
    return {
        nrDashboard: {
            nrData: new NRDataActions(),
            productData: new ProductDataActions(),
            nrHeaderData: new NRHeaderDataActions(),
            nrEmployeeData: new EmployeeActions(),
        },
        partnerNRDashboard: {
            partnerNRSummaryData: new PartnerNRSummaryDataActions(),
        },
    };
});
